<template>
    <a-drawer
      :title="'创新项目-'+actionName"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      width="30%"
    >
        <div class="input-box">
            <p>项目编号：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.id" />
        </div>
        <div class="input-box">
            <p>立项年度：</p>
            <a-date-picker 
                class="input" 
                mode='year'
                format='YYYY年'
                :open='yearShowOne'
                v-model="info.decideDate" 
                @openChange="openChangeOne"
                @panelChange="panelChangeOne" 
                :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>项目类型：</p>
            <a-select
                class="input"
                show-search
                :filter-option="filterOption"
                @search="handSearch"
                v-model="info.projectTypeCode"
                allowClear
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in xmlxArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>项目级别：</p>
            <a-select
                class="input"
                show-search
                :filter-option="filterOption"
                v-model="info.projectLevelCode"
                allowClear
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in xmjbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>项目名称：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.projectName" />
        </div>
        
        <div class="input-box">
            <p>项目负责人学号：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.chargeStudentNo" />
        </div>
        <div class="input-box">
            <p>项目负责人姓名：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.chargeStudentName" />
        </div>
        <div class="input-box">
            <p>指导老师：</p>
            <a-select 
                class="input" 
                allowClear
                show-search
                :filter-option="false"
                @search="teacherSearch"
                v-model="info.guideTeacherNo"
                @change="teacherChange"
                option-label-prop="label"
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.teacherId" :label="item.teacherName">{{item.teacherId}}-{{item.teacherName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>组员学号及姓名：</p>
            <a-textarea class="input" :rows="2" :disabled="actionName=='查看'" v-model="info.teamMembers" />
        </div>
        <div class="input-box">
            <p>项目经费：</p>
            <a-input-number class="input" :disabled="actionName=='查看'" v-model="info.projectFunds" />
        </div>
        <div class="input-box">
            <p>中期检查时间：</p>
            <a-date-picker class="input" v-model="info.midCheckDate" @change="(date, dateString)=>{info.midCheckDate=dateString}" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>结题时间：</p>
            <a-date-picker class="input" v-model="info.finishDate" @change="(date, dateString)=>{info.finishDate=dateString}" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>备注：</p>
            <a-textarea class="input" :rows="4" :disabled="actionName=='查看'" v-model="info.remark" />
        </div>
        <div class="btn-box">
            <a-button type="primary" @click="sub" v-if="actionName!='查看'">提交</a-button>
            <a-button @click="onClose">取消</a-button>
        </div>
    </a-drawer>

</template>

<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { add,update,info } from '@/baseAPI/undergraduate/student/innovate'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    export default {
        name: '',
        components: {
        },
        computed: {},
        data() {
            return {
                actionName:'',
                visible:false,
                id:'',
                info:{
                    id:null,
                    decideDate:null,
                    projectTypeCode:null,
                    projectLevelCode:null,
                    projectName:null,
                    chargeStudentNo:null,
                    chargeStudentName:null,
                    guideTeacherNo:null,
                    guideTeacherName:null,
                    teamMembers:null,
                    midCheckDate:null,
                    finishDate:null,
                    projectFunds:null,
                    remark:null,
                },
                jsArr:[],
                xmlxArr:[],
                xmjbArr:[],
                yearShowOne:false,
            }
        },
        mounted () {
        },
        methods:{
            getInfo(){
                getDicts({dataCode:'CXXMLX',status:true}).then(res=>{
                    this.xmlxArr=res.data.dicts;
                    this.info.projectTypeCode=res.data.defaultValue[0]
                })
                getDicts({dataCode:'CXXMJB',status:true}).then(res=>{
                    this.xmjbArr=res.data.dicts;
                    this.info.projectLevelCode=res.data.defaultValue[0]
                })
                if(this.actionName!='新增'){
                    info(this.id).then(res=>{
                        this.info=res.data;
                        this.teacherSearch(this.info.guideTeacherNo)
                    })
                }
            },
            showDrawer(name,id){
                this.id=id;
                this.actionName=name;
                this.getInfo();
                this.visible=true;
            },
            onClose() {
                this.info={
                    id:null,
                    decideDate:null,
                    projectTypeCode:null,
                    projectLevelCode:null,
                    projectName:null,
                    chargeStudentNo:null,
                    chargeStudentName:null,
                    guideTeacherNo:null,
                    guideTeacherName:null,
                    teamMembers:null,
                    midCheckDate:null,
                    finishDate:null,
                    projectFunds:null,
                    remark:null,
                };
                this.visible = false;
                this.$parent.fetch()
            },
            handSearch(value){
                if(value!=''){
                    this.info.projectTypeCode=value
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            teacherSearch(value){
                getTeacher({teacherName:value}).then(res=>{
                    this.jsArr=res.data;
                })
            },
            teacherChange(value){
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherId==value){
                        this.info.guideTeacherName=this.jsArr[i].teacherName
                    }
                }
            },
            sub(){
                var isSub=true;
                var arr=['remark','approvalStatus']
                console.log(this.info)
                for(let key in this.info){
                    if(arr.indexOf(key)<0){
                        if(this.info[key]==null||this.info[key]===''){
                            isSub=false;
                            break;
                        }
                    }
                }
                if(isSub){
                    if(this.actionName=='新增'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增创新项目成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改创新项目成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },
            openChangeOne(status) {
                if (status){
                    this.yearShowOne =  true
                }
            },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.info.decideDate = this.getTimeStr(value._d,'yyyy');
                this.yearShowOne = false;
            }
        }
    }
</script>

<style scoped>
    .ant-drawer >>> .ant-drawer-header{
        background-color: #245086;
        border-radius: 0;
    }
    .ant-drawer >>> .ant-drawer-title{
        color: #fff;
        font-weight: bold;
        letter-spacing: 1px;
        font-size: 1.1rem;
    }
    .input-box{
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .input-box p{
        width: 9rem;
        text-align: right;
    }
    .input-box .input{
        width: calc(100% - 9rem);
    }
    .input-box .tips{
        width: calc(100% - 9rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .btn-box{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: right;
        padding-bottom: 1rem;
        background-color: #fff;
    }
    .btn-box .ant-btn{
        margin-right: 2rem;
    }
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled,.ant-calendar-picker >>> .ant-input[disabled]{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }

</style>
